import { XButton } from '#assets/svg';
import { Text } from '#atoms';
import { PATH } from '#const/path';
import { Modal } from '#molecules';
import {
  SERACH_QUERY,
  useDashboardChartFormProcess
} from '#pages/DashboardChartForm/hooks/useDashboardChartFormProcess';
import { Button } from '#pages/DashboardCustomer/styles';
import TagManager from 'react-gtm-module';
// import { useQuery } from '@tanstack/react-query';
import { useNavigate } from 'react-router';

interface DashboardChartModalProps {
  onClose: () => void;
  registeredLectureId: string;
  previousRegisteredLectureId?: string;
}
export const DashboardChartModal = ({
  onClose,
  registeredLectureId,
  previousRegisteredLectureId
}: DashboardChartModalProps) => {
  const navigate = useNavigate();

  // const { data } = useQuery(
  //   [queryKeyFactory.GET_RECORD_V2(previousRegisteredLectureId as string)],
  //   () => getRecordV2(previousRegisteredLectureId as string),
  //   {
  //     enabled: !!previousRegisteredLectureId
  //   }
  // );

  const { setTab } = useDashboardChartFormProcess();

  // 새로 작성하기 버튼에 들어갈 콜백 함수
  const onNewWrite = () => {
    TagManager.dataLayer({
      dataLayer: {
        event: 'exercisechart_new_click',
        category: '회원관리',
        action: 'exercisechart_new_click',
        value: 2
      }
    });
    navigate(
      `${PATH.DASHBOARD_CHART_FORM}?${SERACH_QUERY.REGISTERED_LECTURE_ID}=${registeredLectureId}`
    );
    setTab('운동 선택');
  };

  // 프리셋 선택하기 버튼에 들어갈 콜백 함수
  const onSelectPreset = () => {
    TagManager.dataLayer({
      dataLayer: {
        event: 'exercisechart_preset_click',
        category: '회원관리',
        action: 'exercisechart_preset_click',
        value: 2
      }
    });
    navigate(
      `${PATH.DASHBOARD_CHART_FORM}?${SERACH_QUERY.REGISTERED_LECTURE_ID}=${registeredLectureId}`
    );
    setTab('프리셋 선택');
  };

  // 불러오기 버튼에 들어갈 콜백 함수
  const onBringChart = () => {
    navigate(
      `${PATH.DASHBOARD_CHART_FORM}?${SERACH_QUERY.REGISTERED_LECTURE_ID}=${registeredLectureId}&${SERACH_QUERY.PREVIOUS_REGISTERED_LECTURE_ID}=${previousRegisteredLectureId}`
    );
    setTab('폼');
  };

  return (
    <Modal style={{ padding: '24px' }} onClose={onClose}>
      <div className="flex justify-between w-full">
        <Text textStyle="t3">운동차트 작성</Text>
        <XButton onClick={onClose} />
      </div>

      <div className="w-full flex flex-col gap-8">
        <Button onClick={onNewWrite}>
          <div className="title">새로 작성하기</div>
          <div className="desc">운동차트를 새로 작성합니다</div>
        </Button>
        <Button onClick={onSelectPreset}>
          <div className="title">프리셋 선택하기</div>
          <div className="desc">저장된 운동 프리셋을 선택합니다</div>
        </Button>
        {previousRegisteredLectureId && (
          <Button onClick={onBringChart}>
            <div className="title">불러오기</div>
            <div className="desc">
              저번 회차 운동차트 <br /> 내용을 불러옵니다
            </div>
          </Button>
        )}
      </div>
    </Modal>
  );
};
